import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <img
              src="/images/logo.webp"
              alt="Brand Warehouse logo — ecommerce fulfillment in Rocklin, California"
              width="333"
              height="106"
              loading="lazy"
            />
            <p>
              The Sacramento-area fulfillment partner built by people who ran
              online stores themselves. Let us help you be the best brand you
              can be.
            </p>
          </div>

          <div className="footer__col">
            <h3>Company</h3>
            <Link to="/services">Services</Link>
            <Link to="/technology">Technology</Link>
            <Link to="/about">Our Story</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/quote">Get a Quote</Link>
          </div>

          <div className="footer__col">
            <h3>Services</h3>
            <Link to="/services">B2C Fulfillment</Link>
            <Link to="/services">B2B &amp; Freight</Link>
            <Link to="/services">Kitting &amp; Co-Packing</Link>
            <Link to="/services">Product Photography & Videography</Link>
          </div>

          <div className="footer__col">
            <h3>Visit Us</h3>
            <p>
              130 Cyber Court, Suites A&amp;B<br />
              Rocklin, CA 95765<br />
              Just off I-80 East
            </p>
            <a
              href="tel:19166621333"
              data-webmcp-action="call-brand-warehouse"
              data-webmcp-description="Call Brand Warehouse at its confirmed business phone number"
              data-webmcp-inputs="none"
            >(916) 662-1333</a>
            <a href="mailto:info@brandretailers.com">info@brandretailers.com</a>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} Brand Warehouse, Inc. All rights reserved.</p>
          <p><time dateTime="2026-08-21">Updated August 21, 2026</time> · 15+ years of ecommerce fulfillment · Rocklin, California</p>
        </div>
      </div>
    </footer>
  );
}

